<li class="list-inline-item gt-icon gt-icon-linkedin border-solid border border-default bg-white" (click)="linkedinSignIn()"></li>
